import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-show-hide',
    template: `
    <span class="controls">
      {{show ? value : '*********'}}
      <button class="btn btn-default btn-xs" title="{{show ? 'Hide' : 'Show'}}" (click)="toggle()">
        <i class="material-icons">{{show ? 'visibility_off' : 'visibility'}}</i>
      </button>
    </span>
  `,
    styles: [
        '.controls {display: block; margin-bottom: 3px; }',
        'button {float:right}'
    ],
    standalone: true
})
export class ShowHideComponent {

  @Input() value: string;
  @Input() show = false;

  constructor() {

  }

  toggle() {
    this.show = !this.show;
  }

}
